// pages/TowClampList.js

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { firestore } from "../firebaseConfig";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { toast } from "react-toastify";

const TowClampList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(
      collection(firestore, "tow_clamp_collection"),
      orderBy("createdAt", "desc")
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const list = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setData(list);
        setLoading(false);
      },
      (error) => {
        console.error(error);
        toast.error("Error fetching data");
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Tow / Clamp</h2>

      {/* Add Button */}
      <button
        onClick={() => navigate("/tow-clamp/create")}
        style={styles.addBtn}
      >
        + Add Case
      </button>

      {/* Loading */}
      {loading && <p>Loading...</p>}

      {/* Empty */}
      {!loading && data.length === 0 && (
        <p style={{ textAlign: "center" }}>No records found</p>
      )}

      {/* List */}
      {data.map((item) => (
        <div
          key={item.id}
          style={styles.card}
          onClick={() => navigate(`/tow-clamp/${item.id}`)}
        >
          <div style={styles.row}>
            <h3>{item.vehicleNumber}</h3>
            <span
              style={{
                ...styles.badge,
                background:
                  item.type === "Tow" ? "#dc2626" : "#f59e0b",
              }}
            >
              {item.type}
            </span>
          </div>

          <p style={styles.sub}>
            {item.vehicleType} • {item.reason || "-"}
          </p>

          <p style={styles.meta}>
            ₹{item.amount || 0}
          </p>

          {item.createdAt && (
            <p style={styles.date}>
              {new Date(item.createdAt.seconds * 1000).toLocaleString()}
            </p>
          )}
        </div>
      ))}
    </div>
  );
};

const styles = {
  container: {
    padding: "12px",
    paddingBottom: "80px",
  },
  title: {
    marginBottom: "10px",
  },
  addBtn: {
    width: "100%",
    padding: "14px",
    background: "#33AE54",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    marginBottom: "12px",
    fontWeight: "600",
  },
  card: {
    padding: "14px",
    background: "#fff",
    borderRadius: "12px",
    marginBottom: "10px",
    boxShadow: "0 3px 10px rgba(0,0,0,0.08)",
    cursor: "pointer",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  badge: {
    color: "#fff",
    padding: "4px 10px",
    borderRadius: "20px",
    fontSize: "12px",
  },
  sub: {
    margin: "5px 0",
    color: "#555",
    fontSize: "13px",
  },
  meta: {
    fontWeight: "600",
  },
  date: {
    fontSize: "11px",
    color: "#888",
    marginTop: "5px",
  },
};

export default TowClampList;